import axios from 'axios';
import { SystemOption, SystemOptionDTO } from '../models/systemOptions';
import apiClient from './api';

export const getSystemOptionsByID = async (id: number) : Promise<SystemOption> => {
    const response = await apiClient.get(`/systemOptions/${id}`);
    
    return response.data;
}

export const getSupportPageOptions = async () : Promise<SystemOption> => {
    const response = await apiClient.get(`/systemOptions/supportPage`);
    return response.data;
}

export const updateSystemOption = async (id: number, updatedOption: SystemOptionDTO) : Promise<void> => {
    await apiClient.put(`/systemOptions/${id}`, updatedOption);
}